import { createContext, useContext } from 'react';
import { List } from '../types';

type ModalContextState = {
  listToDelete: List | null;
  showDeletionModal: (list: List) => void;
  hideModal: () => void;
};

export const defaultState: ModalContextState = {
  hideModal: () => null,
  listToDelete: null,
  showDeletionModal: () => null,
};

export const ModalContext = createContext(defaultState);

export const useModalContext = () => useContext(ModalContext);
